import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { PaymentMethodsResponse } from '../../entities';
import { PaymentMethodsDataService } from '../../infrastructure';

import * as PaymentActions from './methods.actions';

@Injectable()
export class MethodsEffects {
    private readonly actions$ = inject(Actions);
    private readonly paymentMethodsDataService = inject(PaymentMethodsDataService);

    loadMethods$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PaymentActions.loadPaymentMethods),
            switchMap(() =>
                this.paymentMethodsDataService.getPaymentMethods().pipe(
                    map((response: PaymentMethodsResponse) => PaymentActions.loadPaymentMethodsSuccess(response)),
                    catchError((error: HttpErrorResponse) => of(PaymentActions.loadPaymentMethodsFailure({ error })))
                )
            )
        )
    );
}
